
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyConicalConeUp as ObiBuoyConicalConeUpElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-conical-cone-up.js';
 
 
 

 
 export const ObiBuoyConicalConeUp = createComponent({
   react: React,
   tagName: 'obi-buoy-conical-cone-up',
   elementClass: ObiBuoyConicalConeUpElement,
   events: {
     
   }
  });
 
 